import moment from 'moment';

export default function readableTime(timeString) {
    const mtime = moment(timeString);
    if (!mtime.isValid()) {
        console.warn('invalid time', mtime, timeString);
    }
    return moment(timeString).format('DD.MM.YYYY HH:mm');
}

export function readableTimeWithTextMonth(timeString) {
    const mtime = moment(timeString);
    if (!mtime.isValid()) {
        console.warn('invalid time', mtime, timeString);
    }
    return moment(timeString).format('LLL');
}
